import type * as Types from '../base-types.graphql';

import { gql } from '@apollo/client';
export type GqlStgFieldsFragment = { companyId: string, createdAt: string, id: string, kind: Types.GqlTransactionKind, shareIssueId?: string | null, snrShareCapitalChangeId?: string | null, sortOrder: number, splitFactor?: string | null, transactionDate: string, updatedAt: string, warrantProgramId?: string | null };

export const StgFieldsFragmentDoc = gql`
    fragment StgFields on ShareTransactionGroup {
  companyId
  createdAt
  id
  kind
  shareIssueId
  snrShareCapitalChangeId
  sortOrder
  splitFactor
  transactionDate
  updatedAt
  warrantProgramId
}
    `;